import type { Key, MutatorCallback } from 'swr'

type GlobalMutate = (
  key?: Key | MutatorCallback,
  data?: unknown,
  opts?: { revalidate?: boolean },
) => Promise<unknown>

export const revalidateClientCaches = (mutate: GlobalMutate) =>
  mutate(
    (key) => typeof key === 'string' && key.startsWith('/api/clients'),
    undefined,
    { revalidate: true },
  )
